import cmp from './SplashScreen'

export default cmp
